import jwt from "jsonwebtoken";

export default function queryCreator(params) {
  let token = jwt.sign(params, "bidbox");
  return token;
}
